import React, { useState } from "react";
import { Play } from "lucide-react";
import { SHOWREEL } from "../../data/content";
import { Reveal, Kicker, RevealHeading } from "./primitives";

export const ShowreelFeature = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="reel" className="relative py-14 md:py-28 px-4 md:px-10" data-testid="showreel-feature">
      <div className="mx-auto max-w-[1600px]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 md:gap-6 mb-8 md:mb-14">
          <div>
            <Kicker index="00">The Showreel</Kicker>
            <RevealHeading text="Latest Reel" className="display-h2 mt-3 md:mt-5" />
          </div>
          <p className="max-w-sm text-xs md:text-sm text-muted-foreground leading-relaxed">
            A cut of our most recent action, stunt and fight design work — shot, rigged and
            choreographed by the CF Action Design team.
          </p>
        </div>

        <Reveal y={60}>
          <div className="flex items-center justify-between mb-3 md:mb-4">
            <span className="kicker text-[10px] md:text-xs">CF Action Design — Showreel</span>
            <span className="kicker text-[10px] md:text-xs hidden sm:inline">Play With Sound</span>
          </div>

          {playing ? (
            <div className="relative w-full aspect-[16/10] md:aspect-[16/7] bg-[#0a0a0a] border border-border overflow-hidden">
              <iframe
                title="CF Action Design Showreel"
                src={`https://www.youtube.com/embed/${SHOWREEL.youtubeId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
                allow="autoplay; encrypted-media; fullscreen"
                allowFullScreen
                className="absolute inset-0 h-full w-full"
                data-testid="video-showreel"
              />
            </div>
          ) : (
            <button
              onClick={() => setPlaying(true)}
              className="group relative block w-full aspect-[16/10] md:aspect-[16/7] bg-[#0a0a0a] border border-border overflow-hidden cursor-pointer active:scale-[0.99] transition-transform"
              data-testid="showreel-thumbnail"
              aria-label="Play showreel"
            >
              <img
                src={SHOWREEL.thumbnail}
                alt="CF Action Design — Chethan D'Souza Action Design Showreel"
                className="absolute inset-0 h-full w-full object-cover grayscale-[0.6] group-hover:grayscale-0 group-hover:scale-[1.03] transition-all duration-300"
              />
              <div className="absolute inset-0 bg-background/30 group-hover:bg-background/10 transition-colors duration-300" />
              {/* Play button */}
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-12 w-12 sm:h-14 sm:w-14 md:h-16 md:w-16 items-center justify-center rounded-full border border-white/70 bg-white/10 backdrop-blur-sm group-hover:bg-white/20 group-hover:scale-110 active:scale-95 transition-all duration-300 shadow-2xl">
                  <Play size={20} className="text-white fill-white ml-0.5 md:w-6 md:h-6" />
                </span>
              </span>
              <span className="absolute bottom-4 left-4 md:bottom-6 md:left-6 kicker text-[10px] md:text-xs bg-background/60 backdrop-blur-md px-2.5 py-1 border border-border/50">
                Watch Showreel ↗
              </span>
            </button>
          )}
        </Reveal>
      </div>
    </section>
  );
};
